  <p (click)="scrollToTarget()"
     (keyup)="scrollToTarget()"
     tabindex="0"
     class="inline-block hover:text-primary70 transition-colors"
     [ngClass]="getAllClasses()">
    {{ block().textContent }}
  </p>
